<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Classification"
      pageSubtitle="Manage classification and sub classification of documents."
    ></app-navbar>

    <div class="content">
      <app-pending-reviews-banner></app-pending-reviews-banner>
      <div class="tabs-row">
        <div class="toggle-group">
          <button class="toggle-btn" [class.active]="activeTab() === 'documents'" (click)="setActiveTab('documents')">Docs</button>
          <button class="toggle-btn" [class.active]="activeTab() === 'repos'" (click)="setActiveTab('repos')">Repos</button>
        </div>
      </div>

      <ng-container *ngIf="activeTab() === 'documents'">
        <h3 class="filters-title">Filters</h3>

        <div class="filters-row">
          <select class="filter-select" [value]="dataSourceFilter()" (change)="onDataSourceFilterChange($event)">
            <option value="">Data Source</option>
            <option *ngFor="let opt of dataSourceOptions()" [value]="opt">{{ opt }}</option>
          </select>

          <select class="filter-select" [value]="classificationFilter()" (change)="onClassificationFilterChange($event)">
            <option value="">Classification</option>
            <option *ngFor="let opt of classificationOptions()" [value]="opt">{{ opt }}</option>
          </select>

          <select class="filter-select" [value]="subClassificationFilter()" (change)="onSubClassificationFilterChange($event)">
            <option value="">Sub Classification</option>
            <option *ngFor="let opt of subClassificationOptions()" [value]="opt">{{ opt }}</option>
          </select>

          <div class="search-box">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input type="text" placeholder="Search..." [value]="searchQuery()" (input)="onSearch($event)" />
          </div>
        </div>

        <div class="table-card">
          <h3 class="table-title">Documents ({{ filteredDocuments().length }})</h3>

          <div class="loading-state" *ngIf="isLoading()">
            <p>Loading documents...</p>
          </div>

          <table class="documents-table" *ngIf="!isLoading() && pagedDocuments().length > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Connector</th>
                <th>Classification</th>
                <th>Sub Classification</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of pagedDocuments()">
                <td class="doc-name-cell">
                  <span class="file-icon" [ngClass]="iconClass(doc.fileExtension)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                  </span>
                  <span class="doc-name">{{ doc.name }}</span>
                </td>
                <td>
                  <span class="connector-badge">
                    <span class="connector-icon">
                      <app-brand-icon [name]="doc.sourceIcon" [size]="16"></app-brand-icon>
                    </span>
                    {{ doc.dataSource }}
                  </span>
                </td>
                <td>{{ doc.classification || '-' }}</td>
                <td>{{ doc.subClassification || '-' }}</td>
                <td>
                  <button class="view-details-btn" (click)="viewDetails(doc)">View Details</button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-state" *ngIf="!isLoading() && pagedDocuments().length === 0">
            <p>No processed documents found.</p>
          </div>
        </div>

        <div class="pagination-row" *ngIf="!isLoading() && filteredDocuments().length > 0">
          <button class="page-nav" [disabled]="currentPage() === 1" (click)="goToPage(currentPage() - 1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>

          <ng-container *ngFor="let p of paginationItems()">
            <span class="page-ellipsis" *ngIf="p === '…'">…</span>
            <button class="page-num" *ngIf="p !== '…'" [class.active]="p === currentPage()" (click)="goToPage(p)">{{ p }}</button>
          </ng-container>

          <select class="page-select" [value]="currentPage()" (change)="onPageSelect($event)">
            <option *ngFor="let p of fullPageNumbers()" [value]="p">{{ p }}</option>
          </select>

          <button class="page-nav" [disabled]="currentPage() === totalPages()" (click)="goToPage(currentPage() + 1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="activeTab() === 'repos'">
        <h3 class="filters-title">Filters</h3>

        <div class="filters-row">
          <select class="filter-select" [value]="repoLanguageFilter()" (change)="onRepoLanguageFilterChange($event)">
            <option value="">Language</option>
            <option *ngFor="let opt of languageOptions()" [value]="opt">{{ opt }}</option>
          </select>

          <select class="filter-select" [value]="repoVisibilityFilter()" (change)="onRepoVisibilityFilterChange($event)">
            <option value="">Visibility</option>
            <option value="Public">Public</option>
            <option value="Private">Private</option>
          </select>

          <div class="search-box">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input type="text" placeholder="Search..." [value]="repoSearchQuery()" (input)="onRepoSearch($event)" />
          </div>
        </div>

        <div class="table-card">
          <h3 class="table-title">Repos ({{ filteredRepos().length }})</h3>

          <div class="loading-state" *ngIf="isLoadingRepos()">
            <p>Loading repositories...</p>
          </div>

          <table class="documents-table" *ngIf="!isLoadingRepos() && pagedRepos().length > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Branch</th>
                <th>Visibility</th>
                <th>Language</th>
                <th>Size</th>
                <th>Last Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let repo of pagedRepos()">
                <td class="doc-name-cell">
                  <span class="file-icon doc-generic">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#181717"><path d="M12 0C5.37 0 0 5.373 0 12c0 5.303 3.438 9.8 8.205 11.387.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.84 1.237 1.84 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.42-1.305.763-1.605-2.665-.305-5.467-1.334-5.467-5.93 0-1.31.468-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.62-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 21.795 24 17.298 24 12c0-6.627-5.373-12-12-12z"/></svg>
                  </span>
                  <span class="doc-name">{{ repo.name }}</span>
                </td>
                <td>{{ repo.defaultBranch || '-' }}</td>
                <td>{{ repo.isPrivate ? 'Private' : 'Public' }}</td>
                <td>{{ repo.language || '-' }}</td>
                <td>{{ formatRepoSize(repo.sizeKb) }}</td>
                <td>{{ formatRepoDate(repo) }}</td>
                <td>
                  <button class="view-details-btn" (click)="viewRepoGraph(repo)">View Graph</button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="empty-state" *ngIf="!isLoadingRepos() && pagedRepos().length === 0">
            <p>No processed repositories found.</p>
          </div>
        </div>

        <div class="pagination-row" *ngIf="!isLoadingRepos() && filteredRepos().length > 0">
          <button class="page-nav" [disabled]="repoCurrentPage() === 1" (click)="goToRepoPage(repoCurrentPage() - 1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>

          <ng-container *ngFor="let p of repoPaginationItems()">
            <span class="page-ellipsis" *ngIf="p === '…'">…</span>
            <button class="page-num" *ngIf="p !== '…'" [class.active]="p === repoCurrentPage()" (click)="goToRepoPage(p)">{{ p }}</button>
          </ng-container>

          <select class="page-select" [value]="repoCurrentPage()" (change)="onRepoPageSelect($event)">
            <option *ngFor="let p of repoFullPageNumbers()" [value]="p">{{ p }}</option>
          </select>

          <button class="page-nav" [disabled]="repoCurrentPage() === totalRepoPages()" (click)="goToRepoPage(repoCurrentPage() + 1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
